import { render } from "./CustomFieldsTable.vue?vue&type=template&id=8a50d844&scoped=true"
import script from "./CustomFieldsTable.vue?vue&type=script&lang=js"
export * from "./CustomFieldsTable.vue?vue&type=script&lang=js"

import "./CustomFieldsTable.vue?vue&type=style&index=0&id=8a50d844&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a50d844"]])

export default __exports__